import {
    optionsAdministrative,
    optionsFinancial,
    optionsTechnical,
    optionsVolksTotalPortal,
    subTopicSupport,
} from './constants';

const selectThemeOptions = [
    ...optionsAdministrative,
    ...optionsFinancial,
    ...optionsVolksTotalPortal,
    ...optionsTechnical,
];

export const getSupportSubtopicLabel = (subtopic?: string) => {
    if (!subtopic) {
        return '-';
    }

    const selectOption = selectThemeOptions.find(option => option.id === subtopic);
    if (selectOption) {
        return selectOption.label;
    }

    return subTopicSupport[subtopic as keyof typeof subTopicSupport] || '-';
};
